"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const UserController_1 = __importDefault(require("../api/UserController"));
const AuthService_1 = __importDefault(require("../services/AuthService"));
const hui_1 = require("@mit/hui");
const ProfileViewComponent = ({ userProfileStore }) => {
    const [imageUrl, setImageUrl] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        UserController_1.default.fetchPicture().then((url) => {
            setImageUrl(url.value);
        });
    }, []);
    const handleLogout = () => {
        let ignore = AuthService_1.default.logout();
    };
    const subMenuData = [
        {
            icon: 'sign-out', text: 'Logout', state: hui_1.DropDownState.None, onClick: () => {
                AuthService_1.default.logout().then((data) => { });
            }
        },
    ];
    return (0, jsx_runtime_1.jsx)(react_1.Fragment, { children: (0, jsx_runtime_1.jsx)(hui_1.Profile, { darkmode: true, name: (userProfileStore === null || userProfileStore === void 0 ? void 0 : userProfileStore.userProfile.displayName) ? " " + userProfileStore.userProfile.displayName : "", subtitle: "IS&T", imageUrl: imageUrl ? imageUrl : "/MIT_logo.png", submenu: subMenuData }) });
};
const ProfileView = (0, mobx_react_1.inject)('userProfileStore')((0, mobx_react_1.observer)(ProfileViewComponent));
exports.default = ProfileView;
